import { Link } from 'react-router';
import { preload } from 'react-dom';

import errorImage from '../../assets/images/error-state.svg';
import Container from '../container';
import './report-error.scss';

const MessageWrapper = ({ children, fromReportPage }) =>
  fromReportPage ? <Container noBorder>{children}</Container> : <>{children}</>;

const ErrorMessage = ({ fromReportPage }) => {
  preload(errorImage, { as: 'image' });

  const reloadPage = () => window.location.reload();

  return (
    <MessageWrapper fromReportPage={fromReportPage}>
      <div className="report__errorMessage">
        <img src={errorImage} width="308" height="216" alt="Error state" />
        <div className="report__errorMessage__text">
          <h1>{fromReportPage ? 'Report' : 'Page'} not found</h1>
          <p>
            <strong>
              The page you’re looking for doesn’t exist or may have been moved.
            </strong>
          </p>
        </div>
        <div className="report__errorMessage__btns">
          <button
            type="button"
            className="secondaryFatLink"
            onClick={reloadPage}
          >
            Try again
          </button>
          <Link to="/" className="primaryFatLink">
            Back to main
          </Link>
        </div>
      </div>
    </MessageWrapper>
  );
};

export default ErrorMessage;
